import { render, staticRenderFns } from "./SectionCardsAdvantages.vue?vue&type=template&id=e2ee5d22&scoped=true&"
import script from "./SectionCardsAdvantages.vue?vue&type=script&lang=ts&"
export * from "./SectionCardsAdvantages.vue?vue&type=script&lang=ts&"
import style0 from "./SectionCardsAdvantages.vue?vue&type=style&index=0&id=e2ee5d22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ee5d22",
  null
  
)

export default component.exports